//日期转 yyyy-MM-dd
export const parse_date = val => {
    if (val == null || val == "") { return "" }
    let t_date = val.replace(new RegExp(/-/gm), "/");
    let d = new Date(t_date);
    if (isNaN(d.getDate()))
        return "";
    let year = d.getFullYear();
    let month = d.getMonth() + 1;
    let date = d.getDate();
    return year + "-" + (month >= 10 ? month : "0" + month) + "-" + (date >= 10 ? date : "0" + date);
}
// 日期转 yyyy-MM-dd
export const parse_newdate = (val, t) => {
  if (val == null || val === '') {
    return ''
  }
  const date = new Date(val) // 时间戳为10位需*1000，时间戳为13位的话不需乘1000
  const Y = date.getFullYear() + '-'
  const M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
  const D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate())
  const h = ' ' + (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
  const m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':'
  const s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
  let result = Y + M + D
  if (t === 0) {
    result = Y + M + D + h + m + s
  }
  return result
}
// 0 -> 中文
export const parse_str = (val, dir) => {
    let name = "";
    for (let i = 0, j = dir.length; i < j; i++) {
        if ("" + dir[i].code === "" + val) {
            name = dir[i].name;
            break;
        }
    }
    return name;
}

//清空entity
export const parse_entity = (pojo) => {
    let i = 0;
    for (let i in pojo) {
        if (typeof pojo[i] == "object" && pojo[i] != null) {
            parse_entity(pojo[i])
        } else {
            if (typeof pojo[i] == "string") {
                pojo[i] = "";
            } else if (typeof pojo[i] == "number") {
                pojo[i] = 0;
            }
        }
    }
    return;
}

//yyyy-MM-dd转换为-年-月-日
export const parse_date_znch = val => {
    if (val == null) {
        return "";
    }
    let t_date = val.replace(new RegExp(/-/gm), "/");
    let d = new Date(t_date);
    if (isNaN(d.getDate()))
        return "";
    let year = d.getFullYear();
    let month = d.getMonth() + 1;
    let date = d.getDate();
    return year + "年" + (month >= 10 ? month : "0" + month) + "月" + (date >= 10 ? date : "0" + date) + "日";
}

// 判断日期范围是否准确 - 条件搜索 - 顺便检查输入的日期是否规范
export const validateDateRange = (startDate, endDate, me, msg) => {
    if (startDate && endDate) {
        if (startDate > endDate) {
            me.$alert(msg, "提醒", {
                confirmButtonText: "确定",
                type: "warning"
            });
            return false;
        } else {
            return true;
        }
    } else {
        return true;
    }

}

// 根据获取n位随机数
export const getRandomNum = (n) => {
    var jschars = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];
    var res = "";
    for (var i = 0; i < n; i++) {
        var id = Math.ceil(Math.random() * 35);
        res += jschars[id];
    }
    return res;
}

// 比较两个字符串型式的日期 yyyy-MM-dd - 普元方法
export const compareDate = (startDate, endDate) => {

    startDate = startDate.split("-");
    endDate = endDate.split("-");

    if (startDate[1].charAt(0) == 0) {
        startDate[1] = startDate[1].substring(1);
    }
    if (startDate[2].charAt(0) == 0) {
        startDate[2] = startDate[2].substring(1);
    }

    if (endDate[1].charAt(0) == 0) {
        endDate[1] = endDate[1].substring(1);
    }
    if (endDate[2].charAt(0) == 0) {
        endDate[2] = endDate[2].substring(1);
    }

    if (parseInt(startDate[0]) > parseInt(endDate[0])) {
        return -1;
    } else if (parseInt(startDate[0]) == parseInt(endDate[0])) {
        if (parseInt(startDate[1]) > parseInt(endDate[1])) {
            return -1;
        } else if (parseInt(startDate[1]) == parseInt(endDate[1])) {
            if (parseInt(startDate[2]) > parseInt(endDate[2])) {
                return -1;
            } else if (parseInt(startDate[2]) == parseInt(endDate[2])) {
                return 0;
            } else {
                return 1;
            }
        } else {
            return 1;
        }
    } else {
        return 1;
    }
}

//四舍五入保留2位小数（不够位数，则用0替补）
export const parse_num = (num) => {
    var result = parseFloat(num);
    // if (isNaN(result)) {
    //   alert('传递参数错误，请检查！');
    //   return false;
    // }
    result = Math.round(num * 100) / 100;
    var s_x = result.toString();
    var pos_decimal = s_x.indexOf('.');
    if (pos_decimal < 0) {
        pos_decimal = s_x.length;
        s_x += '.';
    }
    while (s_x.length <= pos_decimal + 2) {
        s_x += '0';
    }
    return s_x;
}


// WEBPACK FOOTER //
// ./src/tool/parse.js